import { Injectable, Signal } from '@angular/core';
import { Observable } from 'rxjs';

import { NotificationsStore } from './notifications.store';
import { NotificationInboxDto } from '../models/notification.interface';

@Injectable()
export class NotificationsQuery {

    constructor(private store: NotificationsStore) {}

    get items(): Signal<NotificationInboxDto[]> {
        return this.store.signal('items');
    }

    get unreadCount(): Signal<number> {
        return this.store.signal('unreadCount');
    }

    get panelOpen(): Signal<boolean> {
        return this.store.signal('panelOpen');
    }

    get filterUnread(): Signal<boolean> {
        return this.store.signal('filterUnread');
    }

    get hasMore(): Signal<boolean> {
        return this.store.signal('hasMore');
    }

    get loading(): Signal<boolean> {
        return this.store.signal('loading');
    }

    get loadingMore(): Signal<boolean> {
        return this.store.signal('loadingMore');
    }

    get nextCursor(): string | null {
        return this.store.get('nextCursor');
    }

    selectItems(): Observable<NotificationInboxDto[]> {
        return this.store.select('items');
    }
}
